/**
 * tsv file operation
 */
export default class Tsv {
  lineDelimiter = '\n';
  columnDelimiter = '\t';

  /**
   * split line
   * @param {string} data
   * @return {array}
   */
  splitLine(data) {
    data = (data || '').replace(/\r/g, '');
    return data.split(this.lineDelimiter);
  }

  /**
   * split column
   * @param {string} data
   * @return {array}
   */
  splitColumn(data) {
    return (data || '').split(this.columnDelimiter);
  }
}



// WEBPACK FOOTER //
// ./src/js/utils/tsv.js